function addGtag(){
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'UA-140218980-1');
    gtag('config', 'G-LM9NX4FNVL');
}
